import React from 'react';
import { trans } from '@spotahome/soyuz/client';

import ServicePlans from './ServicePlans';

import './ServicePlanSection.scss';

const ServicePlanSection = () => (
  <section className="service-plan-section">
    <h3 className="service-plan-section__title">
      {trans('landlord.landing.pricing-table.title')}
    </h3>
    <ServicePlans />
  </section>
);

export default ServicePlanSection;
